import MStepper from './MStepper.vue';

MStepper.install = (app) => {
  app.component('MStepper', MStepper);
};

export { MStepper };
